<template>
  <LcCard
    body-class="my-orders-winnings-body flex gap-100 items-center justify-between"
    class="my-orders-winnings"
    :class="variant"
    shadow="none"
  >
    <div
      class="flex items-center gap-100 font-medium"
      :class="{ 'caption-bold': variant === 'default' }"
    >
      <LcIcon v-if="variant === 'total'" name="winning" />
      <span>
        {{ `${label ?? $t(`myorders.winning.${variant}.label`)}:` }}
      </span>
    </div>

    <div v-if="amount || $slots.default" class="flex-1 text-right font-medium amount">
      <slot>{{ amount ? formatMoney(amount) : '' }}</slot>
    </div>
  </LcCard>
</template>

<script lang="ts" setup>
import type { Money } from '#api/shared/@types/generated/backend/graphql-schema-types'

type MyOrdersWinningsProps = {
  amount?: Money
  label?: string
  variant?: 'default' | 'total'
}

const { variant = 'default' } = defineProps<MyOrdersWinningsProps>()
</script>

<style lang="scss" scoped>
.my-orders-winnings {
  background: token('color/background/accent/win/win/bold');

  &.default {
    :deep(.my-orders-winnings-body) {
      padding: token('size/space/gap/050') token('size/space/gap/100');
    }
  }

  &.total {
    :deep(.my-orders-winnings-body) {
      padding: token('size/space/gap/100') token('size/space/gap/200');
    }
  }

  .amount {
    color: token('color/text/accent/accent-success');
  }
}
</style>
